import { newTracingSheet } from "./tracing-sheet";
import type { Trace } from "../shared/schema";
import type { WorkspaceModel } from "./useWorkspace";
import {
  sourceMeters,
  sourceName,
  setSourceScale,
  type DrawingSource,
} from "./source-scale";
export function SourceControls({
  model,
  source: s,
}: {
  model: WorkspaceModel;
  source: DrawingSource;
}) {
  const { editor } = model;
  return (
    <>
      <details className="property-disclosure">
        <summary>Scale · {sourceMeters(editor, s) ? "set" : "not set"}</summary>
        <small>
          {sourceName(s)} ·{" "}
          {sourceMeters(editor, s) ? "Scale set" : "Not to Scale"}
        </small>
        <button onClick={() => model.choose("calibrate")}>
          Set from a known distance
        </button>
        {sourceMeters(editor, s) > 0 && (
          <button onClick={() => setSourceScale(editor, s, 0, "Not to Scale")}>
            Clear scale
          </button>
        )}
      </details>

      {s.type !== "trace" && (
        <details className="property-disclosure">
          <summary>Tracing paper</summary>
          <button
            onClick={() => {
              const id = newTracingSheet(editor, s);
              if (id) model.annotation.begin(id, true);
            }}
          >
            Lay tracing paper over this
          </button>
          {editor
            .getSortedChildIdsForParent(s.id)
            .map((id) => editor.getShape(id))
            .filter((x): x is Trace => x?.type === "trace")
            .map((t) => (
              <div key={t.id}>
                <button
                  onClick={() =>
                    editor.updateShape({
                      id: t.id,
                      type: t.type,
                      props: { hidden: !t.props.hidden },
                    })
                  }
                >
                  {t.props.hidden ? "Show" : "Hide"} {t.props.name}
                </button>
                <button
                  disabled={t.props.hidden}
                  onClick={() => editor.select(t.id)}
                >
                  Edit trace
                </button>
              </div>
            ))}
        </details>
      )}
    </>
  );
}
